import Vue from 'vue';
import store from '../store';

// 权限指令
Vue.directive('permission', {
  inserted(el, binding) {
    const { value } = binding;
    // 从 store.state.permissions 读取权限，这是登录时单独存储的
    const permissions = store.state.permissions || [];
    
    // 超级权限
    if (permissions.includes('/*')) return;
    
    // 支持字符串或数组
    const requiredPerms = Array.isArray(value) ? value : [value];
    
    // 检查是否有任一权限
    const hasPermission = requiredPerms.some(perm => permissions.includes(perm));
    
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
});

// 角色指令
Vue.directive('role', {
  inserted(el, binding) {
    const { value } = binding;
    const user = store.state.user;
    const roles = user?.roles || [];
    
    const requiredRoles = Array.isArray(value) ? value : [value];
    const hasRole = requiredRoles.some(role => roles.includes(role));
    
    if (!hasRole) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
});
